import { generateRandomString } from "../components/helpers/treeHelperGeneral";
import { IFolderLocation } from "../interfaces/ISharepointDocument";
import { ISiteInfoLocation } from "../interfaces/ISiteInfo";
import { ITessAccountLocation, ITessProjectFolderLocation, ITessProjectLocation } from "../services/TessService";
import { BrandIcons } from "./brandIcons";

export const ComponentTypes = {
  AdvancedSearch: "AdvancedSearch",
  Exchange: "Exchange",
  OneDrive: "OneDrive",
  OneDriveSubFolder: "OneDriveSubFolder",
  Saving: "Saving",
  SavingInBackground: "SavingInBackground",
  SharePoint: "SharePoint",
  SharePointDocuments: "SharePointDocuments",
  SharePointFolders: "SharePointFolders",
  SharePointList: "SharePointList",
  Teams: "Teams",
  TeamDocuments: "TeamDocuments",
  TeamFolders: "TeamFolders",
  GeneralSearch: "GeneralSearch",
  Tess: "Tess",
  TessAccount: "TessAccount",
  TessProject: "TessProject",
  Docubird: "Docubird"
};

export interface IDirectoryLocation {
  id: string;
  name: string;
  imgUrl: string;
  type: string;
  sites?: ISiteInfoLocation[];
  folders?: IFolderLocation[];
  foldersNextHref?: string;
  canExpand: boolean;
  expanded: boolean;
  isLoading?: boolean;
  loaded?: boolean;
  treeType?: DirectoryTreeType;
  randomId: string;
  level: number;
  isServerRefreshed: boolean;
  accounts?: ITessAccountLocation[];
  projectFolders?: ITessProjectFolderLocation[];
  projects?: ITessProjectLocation[];
  actions?: JSX.Element[];
  message?: JSX.Element;
}

export enum DirectoryTreeType {
  location,
  site,
  document,
  channel,
  folder,
  tessAccount,
  tessProjectStatusContainer,
  tessProject,
  docubirdGroup
}

export const Initiallocations: IDirectoryLocation[] = [
  {
    id: "0",
    name: ComponentTypes.Docubird,
    imgUrl: `${process.env.baseUri}/assets/modern-icon-20.svg`,
    type: ComponentTypes.Docubird,
    sites: [],
    canExpand: true,
    expanded: false,
    isLoading: false,
    treeType: DirectoryTreeType.location,
    randomId: generateRandomString(),
    level: 1,
    isServerRefreshed: false
  },
  {
    id: "1",
    name: ComponentTypes.SharePoint,
    imgUrl: BrandIcons.SharePoint20,
    type: ComponentTypes.SharePoint,
    sites: [],
    canExpand: true,
    expanded: false,
    isLoading: false,
    treeType: DirectoryTreeType.location,
    randomId: generateRandomString(),
    level: 1,
    isServerRefreshed: false
  },
  {
    id: "2",
    name: ComponentTypes.Teams,
    imgUrl: BrandIcons.Teams20,
    type: ComponentTypes.Teams,
    sites: [],
    canExpand: true,
    expanded: false,
    isLoading: false,
    treeType: DirectoryTreeType.location,
    randomId: generateRandomString(),
    level: 1,
    isServerRefreshed: false
  },
  {
    id: "3",
    name: ComponentTypes.OneDrive,
    imgUrl: BrandIcons.OneDrive20,
    type: ComponentTypes.OneDrive,
    folders: [],
    canExpand: true,
    expanded: false,
    isLoading: false,
    treeType: DirectoryTreeType.location,
    randomId: generateRandomString(),
    level: 1,
    isServerRefreshed: false
  },
  {
    id: "4",
    name: ComponentTypes.Tess,
    imgUrl: `${process.env.baseUri}/assets/tess_logo.svg`,
    type: ComponentTypes.Tess,
    canExpand: true,
    expanded: false,
    isLoading: false,
    treeType: DirectoryTreeType.location,
    randomId: generateRandomString(),
    level: 1,
    isServerRefreshed: false
  },
  {
    id: "5",
    name: ComponentTypes.Exchange,
    imgUrl: BrandIcons.Outlook20,
    type: ComponentTypes.Exchange,
    canExpand: false,
    expanded: false,
    randomId: generateRandomString(),
    level: 1,
    isServerRefreshed: false
  }
];
